module.exports = __webpack_public_path__ + "media/images/room_menu_icon/discount_passcodes-02721415ff937e62faf115e05751bdd8.png";